<template>
  <b-dropdown class="login_ddown" right text="Enter CRT Hub" variant="link">
    <div v-if="showSpinner" class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <b-form @submit="onSubmit">
      <b-form-group label="Username" label-for="ddown-form-email">
        <b-form-input  id="username" type="text" v-model="form.username" required placeholder="Enter username" size="sm">
        </b-form-input>
      </b-form-group>

      <b-form-group label="Password" label-for="ddown-form-passwd">
        <b-form-input id="password" type="password" v-model="form.password" required placeholder="Enter password" size="sm">
        </b-form-input>
        <b-button variant="link" size="sm" class="m-0 p-0" @click="redirectToForgotPassword">Forgot Password</b-button>
      </b-form-group>

      <b-button type="submit" variant="primary" size="sm">Enter CRT Hub</b-button>
    </b-form>
    <b-alert :show="showAlert" variant="danger" class="mt-2 mb-0">{{this.error}}</b-alert>
  </b-dropdown>
</template>

<script>
import service from "../services/HttpRequestService";
import RedirectWithCusipMixin from "./RedirectWithCusipMixin";

export default {
  mixins: [RedirectWithCusipMixin],
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      error: '',
      showAlert: false,
      showSpinner: false
    }
  },
  methods: {
    redirectToForgotPassword: function () {
      this.$router.push({ path: '/password_forgot' });
    },
    onSubmit(evt) {
      this.showSpinner = true;
      evt.preventDefault();
      service.authenticate(this.form.username, this.form.password).then(res => {
        res.data.username = this.form.username;
        this.$store.commit('login', res.data);
        if (this.$route.query.utm_term) {
          this.redirectToNextPage();
        } else {
          this.$router.push({ path: 'deal_catalog'});
        }
      }).catch(err => {
        this.error = err.response.data.error_description;
        this.showSpinner = false;
        this.showAlert = true;
      })
    }
  }
}
</script>

<style lang="scss">
.login_ddown {
  & > ul {
    width: 200px;
    padding: 10px;
  }
}
</style>
